/* Copyright 2013 - 2024 Waiterio LLC */
import Meal from '@waiterio/model/Meal.js'
import get from '@waiterio/api-client/get.js'

export default function getMeals(restaurantId, startTime, endTime) {
  return get({
    url: `meals?restaurantId=${restaurantId}&startTime=${startTime}&endTime=${endTime}`,
  }).then(meals => meals.map(meal => new Meal(meal)))
}
